import FavoritesTable from "@/components/ListTable/FavoritesTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import { ListProvider } from "@/modules/list";

const Favorites = () => {
  return (
    <ListProvider
      endpoint="user.favorites"
      storageKey={STORAGE_KEYS.MY_SPACE_FAVORITES}
      contextTabValue={TAB_KEYS.MY_SPACE_FAVORITES}
    >
      <FavoritesTable />
    </ListProvider>
  );
};

Favorites.propTypes = {};

export default Favorites;
